import SecureLS from 'secure-ls'
import {getFakeAvatar} from '@/utils/Common'

export const resetState = (state, initialState) => {
    Object.keys(initialState).forEach(key => {
        state[key] =initialState[key]
    })
}

export const Storage = {
    getUser: () => {
        try {
            var ls = new SecureLS()
            var user = ls.get('user')
            return user
        }catch(error){
            return null
        }
    },
    setUser: (user = {}) => {
        try {

            var ls = new SecureLS()
            try{
                if(!user){
                    ls.set('user', user)
                    return
                }
                var storedUser = ls.get('user')
                if(!user.avatar) {
                    user.avatar = !storedUser.avatar ? getFakeAvatar(user.gender) : storedUser.avatar
                }
            }catch (err){
                if(!user.avatar) user.avatar = getFakeAvatar(user.gender)
            }

            ls.set('user', user)
        } catch (error) {
            throw new Error('Error trying to save User', error)
        }
    }
}